module.exports = __webpack_public_path__ + "static/img/screenshots.5390c29.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/screenshots.png
// module id = e0e9
// module chunks = 0